module.exports = __webpack_public_path__ + "static/media/loginSample.b06ace1a.png";